import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import './_DateSelectorGrid.scss';
import { getIsUnselectableByTypeAndMinMax } from '../utils';
import { DatePropType } from '../helpers/common';

function DateSelectorGrid({
  data,
  onItemClick,
  current,
  selected,
  testPrefix,
  minDate,
  maxDate,
  selectedYear,
  currentYear,
  type
}) {
  if (!data) return null;

  return (
    <div className="DateSelectorGrid__root">
      {data.map((value, key) => {
        const isCurrent =
          type === 'months' ? currentYear === selectedYear && value === current : value === current;
        const isSelected = value === selected;
        const isUnselectable = getIsUnselectableByTypeAndMinMax(
          {
            type,
            value,
            selectedYear,
            key
          },
          minDate,
          maxDate
        );
        const dataTestId = `${testPrefix}-${value}-${key}`;

        const buttonClasses = classNames('DateSelectorGrid__item', {
          'DateSelectorGrid__item--current': isCurrent,
          'DateSelectorGrid__item--selected': isSelected,
          'DateSelectorGrid__item--unselectable': isUnselectable
        });

        return (
          <div
            key={key}
            onClick={!isUnselectable ? () => onItemClick(value, key) : undefined}
            className={buttonClasses}
            data-testid={dataTestId}
          >
            {value}
          </div>
        );
      })}
    </div>
  );
}

DateSelectorGrid.propTypes = {
  data: PropTypes.array.isRequired,
  selectedYear: PropTypes.number,
  currentYear: PropTypes.number,
  current: PropTypes.any,
  selected: PropTypes.any,
  testPrefix: PropTypes.string,
  onItemClick: PropTypes.func,
  minDate: DatePropType,
  maxDate: DatePropType,
  type: PropTypes.oneOf(['years', 'months'])
};

export default DateSelectorGrid;
